import React, { Component } from 'react'
import {Chart, registerables} from "chart.js";
import 'chartjs-adapter-luxon'
import {between} from '../../timeFunctions/timeFns'

import "./SingleLineChart.css";

export default class SingleLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.scale = props.zoom ? props.zoom : 1;
    this.chartLineColor = '#3079BA'
    this.myLineChart = undefined;
    this.chartRef = React.createRef();
  }
 
  componentDidMount() {
    Chart.register(...registerables);
    this.buildChart();
  }
  componentDidUpdate() {
    this.scale = this.props.zoom ? this.props.zoom : this.scale;
    this.buildChart();
  }
  componentWillUnmount(){
    if (typeof this.myLineChart !== "undefined")
      this.myLineChart.destroy();
  }
  clipToInterval (series) {
    const pr = this.props
    const result = series.filter ((i, index) => 
        between (pr.chartProps.label[index], pr.startrange, pr.endrange))
    return result
  }

  buildChart = () => {
    const myChartRef = this.chartRef.current.getContext("2d");
    if (this.props.chartProps?.series2) {
        let chartObj = this.chartObjCommon(this.chartLineColor);
        chartObj.type = 'line';
        
        if (typeof this.myLineChart !== "undefined") this.myLineChart.destroy();
        this.myLineChart = new Chart(myChartRef, chartObj);
    }
    return;
  }

  chartObjCommon(lineColor) {
    const animationTime = this.props.chartProps.label.length < 400 ? 1000 : 0;
    const timeconfig = this.timeSeriesTicks();
    const chartObj = {
      defaults: {
        font: "Roboto', sans-serif",
      },

      data: {
        datasets: [{
          label: 'Link Quality',
          data: this.clipToInterval(this.props.chartProps.series2),
          borderColor: '#A9DDD2',
          backgroundColor: '#A9DDD2',
          fill: false,
          type: 'line',
        }],
        labels: this.clipToInterval(this.props.chartProps.label),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: animationTime },     // general animation time 
        hover: { animationDuration: animationTime }, // hover animation time
        responsiveAnimationDuration: animationTime,  // animation duration after a resize 
        plugins: {
          legend: {display: false},
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  if (context.parsed.y === 4294967295 || context.parsed.y === -1)
                    label += "Disconnected"
                  else 
                    label += new Intl.NumberFormat().format(context.parsed.y)
                }
                return label
              }
            }
          }
        },
        scales: {
          x: {
            type: 'time',
            distribution: 'linear',
            ...timeconfig,
            ticks: { display: true },
            grid: {display: false},
         },
          y: {
            id: 'readings',
            type: 'linear',
            position: 'left',
            ticks: { display: true },
            grid: {display: false},
            title: {text:"Link Quality", display: true},
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 100,
         },
        }
      } 
    }
    return chartObj;
  }

  timeSeriesTicks () {
    this.clipToInterval(this.props.chartProps.data)
    const timeSeries = this.clipToInterval(this.props.chartProps.label)
    if (timeSeries && timeSeries.length > 0) {
      const interval = (timeSeries[timeSeries.length-1] - timeSeries[0]) / (1000*60*60)
      const options = [{name:'hour', max: 48, scale:1}, {name:'day', max: 24*7, scale:24}, 
        {name: 'week', max:24*7*6, scale:24*7}, {name: 'month', max:Number.MAX_VALUE, scale:24*30 }]
      let unitIndex = options.findIndex (opt => opt.max >= interval)
      const step = Math.max((interval / options[unitIndex].scale) / 5, 1)
      return {time: {unit: options[unitIndex].name, stepSize: step, }}
    } 
    return {time: {unit: 'hour', stepSize: 1, }}
  }
  render() {
    return (
      <div className='chart-container' style={{ height: '300px' }}>
        <canvas id="myChart" ref={this.chartRef} />
      </div>
    )
  }
}
